// Api container

import AxiosApiController from './axiosApiController';

const axiosController = () => new AxiosApiController();

const apiContainer = {
  apiController: axiosController,
};

export default apiContainer;
